// see https://os.alfajango.com/easytabs/#required-markup

// "parent" is expected to be a container which contains an > ul of links, each link should have a href which corresponds to the ID of a div
// pass in tabElement if ul is not a direct child etc

class Tabs {

    constructor(parent, customElement=false, fade=0) {

        $(parent).easytabs({
            animate: fade !== 0,
            animationSpeed: fade,
            updateHash: false,
            defaultTab: 'li:first-child',
            tabs: customElement ? customElement : ' > ul > li'
        });
    }
}

export { Tabs as default }